export default __webpack_public_path__ + "static/media/511.253cc0a8.png";